const updatePreviewInfo = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const {
                resumeDate,
                rescheduleDate,
                gameData: {
                    teams = {},
                    venue = {},
                    datetime: {
                        dateTime = ''
                    } = {},
                    status: {
                        startTimeTBD,
                        extendedStatus: {
                            isPreGameDelay,
                            isCancelled,
                            isPostponed,
                            isSuspended
                        } = {}
                    } = {}
                } = {}
            } = action?.data || {};

            return {
                ...state,
                teams,
                startTimeTBD,
                venue,
                dateTime,
                isPreGameDelay,
                isCancelled,
                isPostponed: isPostponed && !rescheduleDate,
                isSuspended: isSuspended && !resumeDate
            };
        } else if (datasource === 'schedule') {
            const {
                teams = {}
            } = action?.data || {};

            return {
                ...state,
                ticketLink: teams?.home?.tickets
            }
        } else if (datasource === 'standings') {
            const {
                dataByTeams = {}
            } = action?.data || {};

            return {
                ...state,
                standingsData: dataByTeams
            }
        }
    }

    return state;
};

export default updatePreviewInfo;
